import React from 'react';
import bodyScrollLock from 'services/bodyScrollLock'

export default function WrongEmailSent() {
  const handleOnClick = (event) => {
    event.preventDefault();
    const modal = document.querySelector('#modal-popup-wrong-email-sent');

    modal.classList.add('active');

    bodyScrollLock.disableScroll(modal);
  };

  return (
    <a
      href="#!"
      className="font-bold no-border font-size-xxs"
      onClick={handleOnClick}
    >
      Keine E-Mail erhalten?
    </a>
  );
}
